"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serialization_error_1 = require("../errors/serialization_error");
const metadata_1 = require("../metadata");
const boolean_serializer_1 = require("./boolean_serializer");
const number_serializer_1 = require("./number_serializer");
const serializable_serializer_1 = require("./serializable_serializer");
const string_serializer_1 = require("./string_serializer");
var SerializerFactory;
(function (SerializerFactory) {
    /** Tries to pick a default serializer for given property */
    function createFor(target, propertyName, options) {
        const ctor = Reflect.getMetadata('design:type', target, propertyName);
        if (ctor === undefined) {
            throw new Error('Unable to fetch type information. Hint: Enable TS options: `emitDecoratorMetadata` and `experimentalDecorators`');
        }
        if (ctor === String) {
            return new string_serializer_1.default(propertyName, options);
        }
        else if (ctor === Number) {
            return new number_serializer_1.default(propertyName, options);
        }
        else if (ctor === Boolean) {
            return new boolean_serializer_1.default(propertyName, options);
        }
        else if (ctor.prototype && metadata_1.default.getFor(ctor.prototype)) {
            return new serializable_serializer_1.default(propertyName, options, ctor);
        }
        else {
            throw new serialization_error_1.default(`Unable to find serializer for type: "${ctor.name}". Hint: use serializable type or provide a custom serializer`);
        }
    }
    SerializerFactory.createFor = createFor;
})(SerializerFactory || (SerializerFactory = {}));
exports.default = SerializerFactory;
//# sourceMappingURL=serializer_factory.js.map